// import { Tween, Easing } from "@tweenjs/tween.js";
import { COMPONENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { BetAmount } from '../../view/action-buttons/BetAmountView';
import { SpinButtons } from '../../view/action-buttons/SpinButtonsView';
import { InfoButtons } from '../../view/additional-components/InfoButtonsView';
import { LogoView } from '../../view/additional-components/LogoView';
import { StatusBar } from '../../view/additional-components/StatusBarView';
import { ReelHolderView } from '../../view/reel/ReelHolder';
import { BonusBuyWidget } from '../../view/widgets/BonusBuyWidget';
import { DoubleChanceWidget } from '../../view/widgets/DoubleChanceWidget';
// import { QuestWidget } from '../../view/widgets/QuestWidget';
import MainGridController from '../../controllers/grid/MainGridController';
import { MainViewGrid } from '../../view/MainViewGrid';
import { DoubleChanceWidgetMobile } from '../../view/widgets/DoubleChanceWidgetMobile';
import { StatusBarBg } from '../../view/additional-components/StatusBarBg';
import { WinAmount } from '../../view/additional-components/WinAmountView';
import { WinInfo } from '../../view/additional-components/WinInfoView';
// import { NotificationView } from '../../view/notifications/NotificationView';
// import { ErrorView } from '../../view/notifications/ErrorView';
// import { FastplayDialogueView } from '../../view/fastplay-dialogue/FastplayDialogue';
// import { BonusGameDialogueView } from "../../view/bonus-game/BonusGameDialogueView";
// import { FreespinWinView } from "../../view/freespin/FreespinWinView";
// import { FreespinPromptView } from "../../view/freespin/FreespinPromptView";
// import { FreespinStatusbarView } from "../../view/freespin/FreespinStatusbarView";
// import { PromptView } from "../../view/prompt/PromptView";
// import { WinHighlight } from "../../view/win-highlight/WinHighlightView";
// import { BonusGameFinishedView } from "../../view/bonus-game/BonusGameFinished";

export default function addViews(that) {
	const views = [
		StatusBar,
		StatusBarBg,
		WinAmount,
		WinInfo,
		LogoView,
		ReelHolderView,
		SpinButtons,
		BetAmount,
		// QuestWidget,
		BonusBuyWidget,
		InfoButtons,
		// FastplayDialogueView,
		// QuestPromptView,
		// BonusGameDialogueView,
		// FreespinWinView,
		// FreespinPromptView,
		// FreespinStatusbarView,
		// PromptView,
		// WinHighlight,
		// BonusGameFinishedView,
		// ErrorView,
		// NotificationView,
		window.isMobile || window.isTablet
			? DoubleChanceWidgetMobile
			: DoubleChanceWidget
	];
	if (GameConfigs.settings.background_music) {
		window.sm.play({ name: 'bg_music_lvl1', loop: true, background: true });
	}

	for (let i = 0; i < views.length; i++) {
		GameConfigs.uiComponent.addView(views[i]);
	}
	GameConfigs.uiComponent[COMPONENTS.REEL]
		.getChildByName('reel_bg', true)
		.addChild(that.reels);

	that.removeChild(that.splash);
	delete that.splash;
	GameConfigs.uiComponent.gridController = new MainGridController(
		GameConfigs.uiComponent,
		MainViewGrid
	);
	GameConfigs.uiComponent.resize(window.CurrentSize.w, window.CurrentSize.h);
	// that.viewTransitions.animateReelEnter()
	// that.viewTransitions.addBonusRoundViews()
}
